import { Route, Routes } from "react-router-dom";

import { ResultBlocker, ResultButton } from "../Result";

interface Props {
  children: JSX.Element[] | JSX.Element;
  onBack?: () => void;
}

export const RoutesWithNotFound = ({ children, onBack }: Props) => {
  return (
    <Routes>
      {children}
      <Route
        element={
          <div className="flex h-full w-full items-center justify-center">
            <ResultBlocker showGoHome={false} status="notFound">
              {onBack && <ResultButton onClick={onBack}>Volver al inicio</ResultButton>}
            </ResultBlocker>
          </div>
        }
        path="*"
      />
    </Routes>
  );
};
